import QrTeamsPreview from '../pages/admin/qr-teams/qr-teams-preview'
export default QrTeamsPreview
